import Name from './Name.jsx';

// Block-id contract for the private-view template. The producer (dash MigrationManager
// presentation template) and consumers (dash PresentationBuilder retrieval,
// Inventory.Visibility.deriveVisibility) all reference these so an id can't desync.
const PrivateView = {
    PageField: {
        Company: 'company',
        Description: 'description',
        Logo: 'logo',
        Subtitle: 'subtitle',
        Title: 'title'
    },

    CellField: {
        Availability: 'availability',
        Details: 'details'
    },

    pageTextId: (field) => `${Name.Block.Text}-${field}`,

    logoImageId: `${Name.Block.ImageV2}-logo`,

    cellTextId: (field) => `${Name.Block.Inventory.Cell.Text}-${field}`,

    ctaId: Name.Block.Inventory.Button.InquireV3,

    inventoryListId: Name.Block.Inventory.Presentation.List
};
export default PrivateView;
